export default "https://cdn-static.gokick.com/assets/be369b33e14920b1856d71de34d484ec78759d8a/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";